import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

//import l10n from '../../shared/l10n'
//const { foo: { foo } } = l10n

const DownloadExpose = ({ error, success, submit }) => {
  useEffect(() => {
    submit()
  }, [])

  return (
    <div className={`dhsv_download_expose`}>
      {success && (
        <div className={`dhsv_success_message`}>
          <p>{success}</p>
        </div>
      )}
      {error && (
        <div className={`dhsv_error_message`}>
          <p>{error}</p>
        </div>
      )}
      {!success && !error && <span>Download in Anforderung...</span>}
    </div>
  )
}

DownloadExpose.propTypes = {
  error: PropTypes.string,
  success: PropTypes.string,
  submit: PropTypes.func,
}

export default DownloadExpose
